import React, { PropTypes } from 'react'
import { connect } from 'react-redux';
import UpcomingWebinarsView from 'components/Dashboard/UpcomingWebinars/UpcomingWebinars';
import UpcomingWebinarItem from 'components/Dashboard/UpcomingWebinars/UpcomingWebinarItem';
import actions from 'actions';
import constants from 'constants';
import { push } from 'redux-router';
import _ from 'lodash';

const {
  UPCOMING_WEBINARS
} = constants;

const {
  subscribeWebinarSaga,
  unsubscribeWebinarSaga
} = actions;

class UpcomingWebinars extends React.Component {
  constructor(props) {
    super(props);
  }

  webinars = () => (
    this.props.webinars.map(webinar => {
      return(
        <UpcomingWebinarItem
          key={webinar.id}
          webinar={webinar}
          userRole={this.props.userRole}
          toggleSubscription={() => this.toggleSubscription(webinar)}
        />
      )
    })
  )

  toggleSubscription = (webinar) => {
    const { dispatch, isLogged } = this.props;

    if (!isLogged) {
      dispatch(push('/users/sign_in'));
      return;
    }

    if (webinar.subscription_id)
      this.props.unsubscribeWebinar(webinar.subscription_id, webinar.id);
    else
      this.props.subscribeWebinar(webinar);
  }

  render() {
    return(
      <UpcomingWebinarsView
        nextPage={this.props.nextPage}
        webinars={this.webinars()}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
      />
    )
  }
}

UpcomingWebinars.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
  unsubscribeWebinar: PropTypes.func,
  pages: PropTypes.integer
}

const mapStateToProps = (state) => ({
  pages: state.webinars[UPCOMING_WEBINARS].pages,
  isLogged: !_.isEmpty(state.users.user),
  userRole: state.users.user.user_type
})

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar)),
  unsubscribeWebinar: (id, weinbarId) => dispatch(unsubscribeWebinarSaga(id, weinbarId)),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingWebinars);



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/UpcomingWebinars/UpcomingWebinars.jsx
 **/